import {
  Swiper,
  Navigation,
  Keyboard,
} from 'swiper/dist/js/swiper.esm.js';

export default class Slider {
  constructor(elem, parameters) {
    this.elem = elem;
    this.parameters = parameters;
    this.addSwiper(this.elem, this.parameters);
    this.addRandomID();
  }

  addSwiper(elem, parameters) {
    let that = this;

    const nextEl = elem.querySelector('.o-slider__navigation--next');
    const prevEl = elem.querySelector('.o-slider__navigation--prev');

    const defaultParameters = {
      loadPrevNextAmount: 2,
      slidesPerView: 3,
      allowTouchMove: true,
      spaceBetween: 32,
      threshold: 10,
      speed: 800,
      watchSlidesVisibility: true,
      watchOverflow: true,

      // Controlls
      keyboard: {
        enabled: false,
      },

      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
        disabledClass: 'o-slider__navigation--disabled',
        hiddenClass: 'o-slider__navigation--hidden',
      },

      // Breakpoints
      breakpoints: {
        // when window width is <= 320px
        740: {
          slidesPerView: 1,
        },
      },

      // Classes
      containerModifierClass: 'o-slider--',
      slideClass: 'o-slider__slide',
      slideActiveClass: 'o-slider__slide--active',
      slideDuplicateActiveClass: 'o-slider__slide--duplicate-active',
      slideVisibleClass: 'o-slider__slide--visible',
      slideDuplicateClass: 'o-slider__slide--duplicate',
      slideNextClass: 'o-slider__slide--next',
      slideDuplicateNextClass: 'o-slider__slide--duplicate-next',
      slidePrevClass: 'o-slider__slide--prev',
      slideDuplicatePrevClass: 'o-slider__slide--duplicate-prev',
      wrapperClass: 'o-slider__wrapper',
    };

    Swiper.use([Navigation, Keyboard]);

    let swiper = new Swiper(elem, Object.assign({
      ...defaultParameters,
      ...parameters,
    }));

    if (swiper.slides && swiper.slides.length - 2 == swiper.slidesPerView) {
      if(prevEl) {
        prevEl.style.display = 'none';
      }
      if(nextEl) {
        nextEl.style.display = 'none';
      }
    }

    this.swiper = swiper;
    this.swiper.on('slideChange', function() {
      that.swiper.updateAutoHeight(500);
    });
  }

  update() {
    this.swiper.destroy(false, false);
    this.addSwiper(this.elem, this.parameters);
  }

  next() {
    this.swiper.slideNext();
  }

  prev() {
    this.swiper.slidePrev();
  }

  slideTo(index) {
    this.swiper.slideTo(index);
  }

  addRandomID() {
    let id = Math.random().toString(36).substr(2, 9);
    $(this.elem).attr('id', id);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/slider.js